import { ActionType, LoadingState } from "../constants/actionTypes";

export default (state = { isLoading: true, posts: [] }, action) => {
    switch(action.type) {
        case LoadingState.START_LOADING:
            return { ...state, isLoading: true };
        case LoadingState.END_LOADING:
            return { ...state, isLoading: false };
        case ActionType.FETCH_ALL:
            return {
                ...state,
                posts: action.payload.data,
                currentPage: action.payload.currentPage,
                numerOfPages: action.payload.numerOfPages
            };
        case ActionType.FETCH_BY_SEARCH:
            return {
                ...state,
                posts: action.payload.data
            };
        case ActionType.FETCH_POST:
            return {
                ...state,
                post: action.payload
            }
        case ActionType.LIKE:
            return {
                ...state,
                posts: state.posts.map((post) => (post._id === action.payload._id ? action.payload: post))
            };
        case ActionType.COMMENT:
                return {
                    ...state,
                    posts: state.posts.map((post) => (post._id === action.payload._id ? action.payload: post))
                };
        case ActionType.CREATE:
            return { ...state, posts: [ ...state.posts, action.payload ]};
        case ActionType.UPDATE:
            return {
                ...state,
                posts: state.posts.map((post) => post._id === action.payload._id ? action.payload : post)
            };
        case ActionType.DELETE:
            return { ...state, posts: state.posts.filter((post) => post._id !== action.payload)};
        default:
            return state;
    }
}
